import { createPaginationEntity } from '@luna/api';

import { fetchFinancingAccount } from './fetchFinancingAccount';
import { fetchFinancingListPage } from './fetchFinancingListPage';

export const {
    useEntity: useFinancingAccount,
    useEntities: useFinancingAccounts,
    entityHelpers: financingAccountsEntityHelpers,
} = createPaginationEntity({
    name: '@products/aggregation/financing',
    payloadCreators: {
        queryById: fetchFinancingAccount,
        queryPage: fetchFinancingListPage,
    },
});
